"use client";
import React from "react";
import Dropdown from "@/components/Dropdown";
import IconCaretDown from "@/components/Icons/icon-caret-down";
import { Trans } from "react-i18next/TransWithoutContext";
import { languages } from "@/app/i18n/settings";
import { useRouter } from "next/navigation";
import { getPublicAssetPath } from "@/utils";

interface LanguageDropdownProps {
  className?: string;
  lang: string;
}

const LanguageDropdown = ({ className = "", lang }: LanguageDropdownProps) => {
  const router = useRouter();

  const replaceLanguage = (path: string, selLang: string = "th") => {
    let pathName = path;
    pathName = pathName.replace(`/${process.env.NEXT_PUBLIC_PATH_URL}/`, `/`);

    languages.forEach((lng) => {
      pathName = pathName.replace(`/${lng}`, `/${selLang}`);
    });

    return pathName;
  };

  const [language, setLanguage] = React.useState(lang);

  const handleChange = (event: any, newLang: string) => {
    setLanguage(newLang);
  };

  return (
    <div className={`dropdown ${className}`}>
      <Trans i18nKey="languageSwitcher">
        {languages && (
          <Dropdown
            offset={[0, 8]}
            //placement={`${isRtl ? 'bottom-start' : 'bottom-end'}`}
            placement={"bottom-end"}
            btnClassName="flex items-center gap-2.5 rounded-lg border border-white-dark/30 bg-white px-2 py-1.5 text-white-dark hover:border-primary hover:text-primary dark:bg-black"
            button={
              <>
                <div>
                  <img
                    src={getPublicAssetPath(
                      `/assets/img/flags/${language.toUpperCase()}.svg`
                    )}
                    alt="image"
                    className="h-5 w-5 rounded-full object-cover"
                  />
                </div>
                <div className="text-base font-bold uppercase">
                  {language.toUpperCase()}
                </div>
                <span className="shrink-0">
                  <IconCaretDown />
                </span>
              </>
            }
          >
            <ul className="grid w-[280px] grid-cols-2 gap-2 !px-2 font-semibold text-dark dark:text-white-dark dark:text-white-light/90">
              {languages.map((item: any) => {
                return (
                  <li key={item.toUpperCase()}>
                    <button
                      type="button"
                      className={`flex w-full rounded-lg hover:text-primary ${
                        language === item ? "bg-primary/10 text-primary" : ""
                      }`}
                      onClick={() => {
                        handleChange(null, item);
                        const params = new URLSearchParams(
                          window.location.search
                        );
                        router.push(
                          `${replaceLanguage(window.location.pathname, item)}${
                            params ? decodeURI(`?${params}`) : ""
                          }`
                        );
                      }}
                    >
                      <img
                        src={getPublicAssetPath(
                          `/assets/img/flags/${item.toUpperCase()}.svg`
                        )}
                        alt="flag"
                        className="h-5 w-5 rounded-full object-cover"
                      />
                      <span className="ltr:ml-3 rtl:mr-3">
                        {item.toUpperCase()}
                      </span>
                    </button>
                  </li>
                );
              })}
            </ul>
          </Dropdown>
        )}
      </Trans>
    </div>
  );
};

export default LanguageDropdown;
